import * as React from 'react';
import classNames from 'classnames';
import * as styles from './styles.css';

interface ILabelProps {
  completionStatus: string;
}

export const Label = ({ completionStatus }: ILabelProps) => {
  return (
    <div className={classNames(styles['label'], completionStatus === 'Сдана' ? styles['green'] : styles['yellow'])}>
      {completionStatus}
    </div>
  );
};
